// TIME CONVENIENCE
const MINUTE = 60;
const HOUR = MINUTE * 60;

export const PERSIST_SHORT_EXPIRY_DEFAULT = MINUTE * 3; // conservative expiry
export const PERSIST_LONG_EXPIRY_DEFAULT = HOUR; // lenient expiry
